import React from "react";
import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";

export default class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.error("Application route failed:", error);
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 3, bgcolor: "background.default" }}>
                <Paper sx={{ maxWidth: 520, p: 4 }}>
                    <Stack spacing={2}>
                        <Typography variant="h5">This workspace view could not load.</Typography>
                        <Alert severity="error">Try refreshing once. If the problem continues, the browser console contains the route error details.</Alert>
                        <Button variant="contained" onClick={() => window.location.reload()}>Reload workspace</Button>
                    </Stack>
                </Paper>
            </Box>
        );
    }
}
